<template>
  <healthchecks-form
    :healthcheck-id="healthcheckId"
    :distribution-id="distributionId"
    details
    @submit="update"
    @close="onClose"
  />
</template>
<script>
import HealthchecksForm from './Form.vue'

export default {
  name: 'EditHealthcheck',
  components: {
    HealthchecksForm,
  },
  data() {
    return {
      distributionId: null,
      healthcheckId: null,
    }
  },
  created() {
    this.distributionId = this.$route.params.id
    this.healthcheckId = this.$route.params.healthcheckId
  },
  methods: {
    update(healthcheck) {
      const query = {
        distributionId: this.distributionId,
        id: this.healthcheckId,
        healthcheck: {
          name: healthcheck.name,
          requestMethod: healthcheck.requestMethod,
          requestPath: healthcheck.requestPath,
          host: healthcheck.host,
          expectedResponse: healthcheck.expectedResponse,
          threshold: healthcheck.threshold,
          window: healthcheck.window,
          interval: healthcheck.interval,
          timeout: healthcheck.timeout,
        },
      }
      this.$store.dispatch('cdn/updateHealthcheck', query).then(() => {
        this.successToast('Healthcheck was updated')
        this.onClose()
      }).catch(error => { this.errorToast(error.response?.data?.errors[0] || 'Something went wrong while updating healthcheck.') })
    },

    onClose() {
      this.$router.push({ name: 'distribution-origins', params: { id: this.distributionId, activeTab: 2 } })
    },
  },
}
</script>
